"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationPriorityOptions = exports.ConversationStatusOptions = void 0;
const misc_1 = require("../../misc");
const enums_1 = require("../../enums");
const ConversationStatusOptions = (t) => (0, misc_1.EnumToArray)(enums_1.ConversationStatusEnum).map(([v, k,]) => ({ key: v, title: t(`STATUS_${v.toUpperCase()}`), }));
exports.ConversationStatusOptions = ConversationStatusOptions;
const ConversationPriorityOptions = (t) => (0, misc_1.EnumToArray)(enums_1.ConversationPriorityEnum).map(([v, k,]) => ({ key: v, title: t(`PRIORITY_${k.toUpperCase()}`), }));
exports.ConversationPriorityOptions = ConversationPriorityOptions;
